export { IMPORTERS, sampleHref, templateHref, useImporters } from '../../shared/import/importers';

/** API paths of the migration module (SDD §21.2). */
export const BATCHES = '/api/v1/migration/batches';
export const ITEMS = '/api/v1/migration/items';

/** A timestamp from the API, in the viewer's locale; a dash when absent. */
export function when(value: string | null): string {
  return value === null ? '—' : new Date(value).toLocaleString();
}

/** Status labels a person reads. */
export const STATUS_LABELS: Readonly<Record<string, string>> = {
  created: 'Created',
  staged: 'Staged',
  validated: 'Validated',
  submitted: 'Awaiting approval',
  approved: 'Approved',
  applying: 'Applying',
  applied: 'Applied',
  reconciled: 'Reconciled',
  locked: 'Locked',
  failed: 'Failed',
};
